/**
 * @file DomainHostCell.tsx
 * @description Ячейка «Адрес» списка доменов магазина (phase19.28 этап А;
 * uiux-platform-shops §7 «Длинные значения»): Юникод и мелко punycode у
 * IDN, перенос по символам, полный адрес — в подсказке.
 */

import type { ShopDomain } from "../../../lib/api-platform-shops";

export function DomainHostCell({ domain }: { domain: ShopDomain }) {
  const unicode = domain.hostUnicode || domain.host;
  return (
    <span className="flex min-w-0 flex-col" title={domain.host}>
      <span className="break-all font-medium">{unicode}</span>
      {unicode !== domain.host ? <span className="type-caption break-all text-on-surface-variant">{domain.host}</span> : null}
    </span>
  );
}
